import React, { useEffect, useState } from 'react';
import Table from '../../../../component/table/Table';
import { useNavigate, useSearchParams } from 'react-router-dom';
import Button from '../../../../component/ui/Button';
import Modal from '../../../../component/modal/Modal';
import AddProductGroup from './AddProductGroup';
import '../Product.scss';
import { product_group_list } from '../../../../store/action/group';
import { useDispatch, useSelector } from 'react-redux';
import sortbydot from '../../../../assets/image/sort_by_group.svg';
import { ExportTable } from '../../../../store/action/export/Export';
import Pagination from '../../../../component/pagination';
import BulkImport from '../BulkImport';
import CreateGroupCodeModel from './createGroupCodeModel';
import { hasPermission } from '../../../../utils/controller';
import { IoIosArrowRoundDown, IoIosArrowRoundUp } from 'react-icons/io';
import ProductGroupModel from '../components/productGroupModel';
import DataNotFound from '../../../components/dataNotFound';

const sortIconMap = {
	asc: <IoIosArrowRoundUp />,
	desc: <IoIosArrowRoundDown />,
};

const ProductGroup = () => {
	const suburl = localStorage.getItem('suburl');
	const [searchParams, setSearchParams] = useSearchParams();
	const [totalPages, setTotalPages] = useState(0);
	const [headerDropDown, setHeaderDropDown] = useState('All Group');
	const [groupCode, setGroupCode] = useState('');
	const [groupId, setGroupId] = useState('');
	const [open, setOpen] = useState(false);
	const [isOpenProductMasterGroup, setIsOpenProductMasterGroup] = useState(false);
	const [buklImport, setIsbuklImport] = useState(false);
	const [loading, setLoading] = useState(false);
	const [isOpenGroupCodeModel, setIsOpenGroupCodeModel] = useState(false);
	const navigate = useNavigate();
	const [row, setRow] = useState([]);
	const user = useSelector((state) => state?.userInfo?.userInfo?.data);
	const [sortDirection, setSortDirection] = useState({});
	const navigateRouter = (path) => {
		navigate(path);
	};
	const [params, setParams] = useState(() => ({
		page: Number(searchParams.get("page")) || 1,
		pageSize: Number(searchParams.get("pageSize")) || 10,
		orderBy: searchParams.get("orderBy") || "",
		sortBy: searchParams.get("sortBy") || "",
		filterBy: searchParams.get("filterBy") || "",
		filterValue: searchParams.get("filterValue") || "",
	}));

	const productGroupColoum = [
		{
			field: 'Group Name',
			headerClass: 'HeaderBg',
			suppressSizeToFit: true,
			minWidth: 200,
			flex: 1,
			headerComponent: () => {
				return (
					<div
						style={{
							width: '100%',
							paddingTop: '10px',
							cursor: 'pointer',
						}}
						onClick={() => {
							sortData({ orderBy: 'name', sortBy: 'asc' });
						}}
					>
						<div
							style={{
								width: '55px',
							}}
						>
							<p
								style={{
									display: 'flex',
									alignItems: 'center',
									color: 'black',
								}}
							>
								Group Name
								<span
									style={{
										fontSize: '18px',
										fontWeight: '800',
									}}
								>
									{sortIconMap[sortDirection?.name]}
								</span>
							</p>
						</div>
					</div>
				);
			},
			cellRenderer: (params) => {
				const data = JSON.parse(params.data['Group Name']);
				return (
					<p
						style={{
							alignItems: 'center',
						}}
					>
						{data?.group_name}
						<span
							style={{ cursor: 'pointer', pointerEvents: 'auto', marginLeft: '10px' }}
							onClick={(e) => {
								e.preventDefault();
								setGroupId(params.data['id']);
								setIsOpenGroupCodeModel(true);
							}}
						>
							{!data?.group_code && '⚠️'}
						</span>
						{data?.status === 0 && (
							<span
								style={{
									backgroundColor: '#718096',
									color: 'white',
									borderRadius: '20px',
									padding: '2px 10px',
									paddingBottom: '3px',
									marginLeft: '10px',
									fontSize: '11px',
								}}
							>
								Inactive
							</span>
						)}
					</p>
				);
			},
		},
		{
			field: 'Group Code',
			headerClass: 'HeaderBg',
			suppressSizeToFit: true,
			minWidth: 200,
			flex: 1,
			headerComponent: () => {
				return (
					<div
						style={{
							width: '100%',
							paddingTop: '10px',
							cursor: 'pointer',
						}}
						onClick={() => {
							sortData({ orderBy: 'code', sortBy: 'asc' });
						}}
					>
						<div
							style={{
								width: '55px',
							}}
						>
							<p
								style={{
									display: 'flex',
									alignItems: 'center',
									color: 'black',
								}}
							>
								Group Code
								<span
									style={{
										fontSize: '18px',
										fontWeight: '800',
									}}
								>
									{sortIconMap[sortDirection?.code]}
								</span>
							</p>
						</div>
					</div>
				);
			},
		},
		{
			field: 'Product Count',
			headerClass: 'HeaderBg right-align',
			cellClass: 'right-align',
			suppressSizeToFit: true,
			minWidth: 150,
			flex: 1,
			headerComponent: () => {
				return (
					<div
						style={{
							width: '100%',
							paddingTop: '10px',
							cursor: 'pointer',
							display: 'flex',
							alignItems: 'center',
							justifyContent: 'end',
						}}
						onClick={() => {
							sortData({ orderBy: 'product_count', sortBy: 'asc' });
						}}
					>
						<div>
							<p
								style={{
									display: 'flex',
									alignItems: 'center',
									color: 'black',
								}}
							>
								Product Count
								<span
									style={{
										fontSize: '18px',
										fontWeight: '800',
									}}
								>
									{sortIconMap[sortDirection?.product_count]}
								</span>
							</p>
						</div>
					</div>
				);
			},
		},
	];

	const groupList = () => {
		setLoading(true);
		product_group_list(params)
			.then((res) => {
				if (res?.success) {
					const { productGroups } = res.data;
					const data = mappedTableData(productGroups);
					setRow(data);
					let toatlPages = Math.ceil(res?.data?.totalCount / params.pageSize);
					setTotalPages(toatlPages);
					setLoading(false);
				} else {
					setLoading(false);
					setRow([]);
				}
			})
			.catch((err) => {
				setRow([]);
				setLoading(false);
			});
	};


	function mappedTableData(data) {
		return data.map((ele) => {
			return {
				id: ele?.product_group_id,
				'Group Name': JSON.stringify({
					id: ele?.product_group_id,
					group_name: ele?.name,
					group_code: ele?.code,
					status: ele?.status,
				}),
				'Group Code': ele?.code,
				'Product Count': ele?.product_count,
			}
		})
	}

	useEffect(() => {
		groupList();
	}, [params]);


	const handleRowClick = (id) => {
		const group = row.find((g) => g.id === id);
		if (!group['Group Code']) return;
		if (hasPermission('inventory.groups.view', user?.role?.role_permissions)) {
			navigateRouter(`/user/${suburl}/group-details/${id}`);
		}
	};

	const handlePageChange = (page) => {
		setParams((prev) => ({
			...prev,
			page: page,
		}))
	};

	const HandleGroupChange = (value, code) => {
		setGroupId(value);
		setGroupCode(code);
	};

	const filterData = (status, label) => {
		setParams((prev) => ({
			...prev,
			filterBy: status === '' ? '' : 'status',
			filterValue: status,
			page: 1,
		}))
		setHeaderDropDown(label)
	};

	const sortData = (param) => {
		const newDirection = sortDirection[param.orderBy] === 'desc' ? 'asc' : 'desc';
		setSortDirection({ [param.orderBy]: newDirection });
		setParams((prev) => ({
			...prev,
			orderBy: param.orderBy,
			sortBy: newDirection,
		}))
	};

	const setFilterFromUrl = () => {
		setSortDirection({
			[searchParams.get("orderBy")]: searchParams.get("sortBy") || "",
		});
		if (searchParams.get("filterBy") === "status") {
			setHeaderDropDown(searchParams.get("filterValue") === "1" ? "Active Groups" : "Inactive Groups")
		} else {
			setHeaderDropDown("All Groups")
		}
	};


	useEffect(() => {
		setFilterFromUrl();
	}, []);

	useEffect(() => {
		const url = new URLSearchParams();
		url.set("page", params.page);
		url.set("pageSize", params.pageSize);
		url.set('orderBy', params.orderBy);
		url.set('sortBy', params.sortBy)
		url.set('filterBy', params.filterBy);
		url.set('filterValue', params.filterValue);
		setSearchParams(url)
	}, [params, setSearchParams]);


	return (
		<div style={{ overflow: 'auto' }}>
			<div className="product-pg-header">
				<div className="d-flex justify-content-start align-items-center gap-4">
					<div className="dropdown text-end">
						<a
							href="#"
							className="d-block link-dark text-decoration-none dropdown-toggle"
							id="dropdownUser1"
							data-bs-toggle="dropdown"
							aria-expanded="false"
						>
							<p>{headerDropDown}</p>
						</a>
						<ul
							className="dropdown-menu font-14"
							aria-labelledby="dropdownUser1"
							style={{ minWidth: '240px' }}
						>
							<li>
								<a
									className="dropdown-item"
									onClick={() => filterData('', 'All Groups')}
								>
									All Groups
								</a>
							</li>
							<li>
								<a
									className="dropdown-item"
									onClick={() => filterData(1, 'Active Groups')}
								>
									Active Groups
								</a>
							</li>
							<li>
								<a
									className="dropdown-item"
									onClick={() => filterData(0, 'Inactive Groups')}
								>
									Inactive Groups
								</a>
							</li>
						</ul>
					</div>
					<Button
						type="button"
						button="Masters Products Groups"
						className="mt-0 px-4 btn-primary"
						onClick={() => setIsOpenProductMasterGroup(true)}
					/>
				</div>

				<div className="d-flex align-items-center">
					<Button
						add
						type="button"
						button="Create New Group"
						disabled={!hasPermission('inventory.groups.create', user?.role?.role_permissions)}
						className="btn-primary mt-0 px-4"
						onClick={() => setOpen(true)}
					/>

					<div className="dropdown text-end ms-3">
						<a
							href="#"
							className="d-block link-dark text-decoration-none"
							id="dropdownUser1"
							data-bs-toggle="dropdown"
							aria-expanded="false"
						>
							<img src={sortbydot} />
						</a>
						<ul
							className="dropdown-menu font-14"
							aria-labelledby="dropdownUser1"
							style={{ minWidth: '240px' }}
						>
							<li>
								<a className="dropdown-item sortBy">Sort By</a>
							</li>
							<li>
								<a
									className="dropdown-item"
									onClick={() => sortData({ orderBy: 'created_at', sortBy: 'asc' })}
								>
									Created Time
								</a>
							</li>
							<li>
								<a
									className="dropdown-item"
									onClick={() => sortData({ orderBy: 'name', sortBy: 'asc' })}
								>
									Name
								</a>
							</li>
							<hr />
							<li>
								<a
									className={`dropdown-item ${!hasPermission('inventory.groups.import', user?.role?.role_permissions) ? 'disabled' : ''}`}
									onClick={() => setIsbuklImport(true)}
								>
									Import Group
								</a>
							</li>

							<li>
								<a
									className={`dropdown-item ${!hasPermission('inventory.groups.export', user?.role?.role_permissions) ? 'disabled' : ''}`}
									onClick={() => ExportTable('product_group')}
								>
									Export Group
								</a>
							</li>

							<hr />
							<li>
								<a
									className="dropdown-item"
									onClick={() => sortData({ orderBy: 'name', sortBy: 'asc' })}
								>
									Preferences
								</a>
							</li>
							<li>
								<a
									className="dropdown-item"
									onClick={() => sortData({ orderBy: 'name', sortBy: 'asc' })}
								>
									Refresh
								</a>
							</li>
						</ul>
					</div>
				</div>
			</div>
			{loading ? (
				<div
					className="d-flex justify-content-center align-items-center"
					style={{ height: '100%', marginTop: '20%' }}
				>
					<span
						className="Page_loader"
						role="status"
						aria-hidden="true"
					></span>
				</div>
			) : row.length > 0 ? (
				<div className="productTable-body">
					<Table
						row={row}
						coloum={productGroupColoum}
						className="productTable"
						onRowClick={handleRowClick}
						style={{ height: 'calc(100vh - 150px)' }}
					/>
				</div>
			) : (
				<DataNotFound
					title={'Organize products into groups!'}
					subtitle={'Manage all your product groups easily.'}
					descriptionTitle={'Stay organized!'}
					descriptionSubTitle={'Group similar products together for easier management'}
					descriptionContent={'and quicker insights — all in one place.'}
					buttonText={'Create New Group'}
					disabled={!hasPermission('inventory.groups.create', user?.role?.role_permissions)}
					onClick={() => setOpen(true)}
				/>
			)}
			{row.length > 0 && (
				<Pagination
					currentPage={params.page}
					totalPages={totalPages}
					onChangePage={handlePageChange}
					pageSize={params.pageSize}
					setParam={(value) => {
						setParams((prev) => ({
							...prev,
							pageSize: value,
							page: 1
						}))
					}}
				/>
			)}
			{open && (
				<div>
					<Modal
						className="add-productgroup-modal"
						isOpen={open}
						cancelButton={() => setOpen(false)}
						onClose={() => setOpen(false)}
						title="Add New Group"
					>
						<AddProductGroup
							isOpen={open}
							onCLose={() => setOpen(false)}
							reloadTable={groupList}
							setGroupCode={setGroupCode}
							openGroupCode={() => {
								setIsOpenGroupCodeModel(true);
							}}
							callBackFunction={HandleGroupChange}
							shouldCallCalback={true}
						/>
					</Modal>
				</div>
			)}
			{isOpenGroupCodeModel && (
				<div>
					<Modal
						className="add-productgroup-modal"
						isOpen={isOpenGroupCodeModel}
						cancelButton={() => setIsOpenGroupCodeModel(false)}
						onClose={() => setIsOpenGroupCodeModel(false)}
						title="Add Group Code"
					>
						<CreateGroupCodeModel
							isOpen={isOpenGroupCodeModel}
							onCLose={() => {
								setIsOpenGroupCodeModel(false);
							}}
							reloadTable={groupList}
							groupCode={groupCode}
							setGroupCode={setGroupCode}
							groupId={groupId}
						/>
					</Modal>
				</div>
			)}
			{isOpenProductMasterGroup && (
				<ProductGroupModel
					isOpenProductGroupModel={isOpenProductMasterGroup}
					setIsOpenProductModel={setIsOpenProductMasterGroup}
					setIsOpenGroupCodeModel={setIsOpenGroupCodeModel}
					setGroupCode={setGroupCode}
					setGroupId={setGroupId}
				/>
			)}
			{buklImport && (
				<div>
					<Modal
						className="add-productgroup-modal"
						isOpen={buklImport}
						onClose={() => setIsbuklImport(false)}
						title=" Group bulk Import "
					>
						<BulkImport
							isOpen={buklImport}
							onClose={() => setIsbuklImport(false)}
							reloadTable={groupList}
							type={'group'}
						/>
					</Modal>
				</div>
			)}
		</div>
	);
};

export default ProductGroup;
